var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOcr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 80",
    style: {
      enableBackground: "new 0 0 64 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "a") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52,11H12c-0.6,0-1,0.4-1,1v27H9.5c-0.6,0-1,0.4-1,1s0.4,1,1,1H11v27c0,0.6,0.4,1,1,1h40c0.6,0,1-0.4,1-1V41 h1.5c0.6,0,1-0.4,1-1s-0.4-1-1-1H53V12C53,11.4,52.6,11,52,11z M13,13h38v26h-4V18c0-0.6-0.4-1-1-1H18c-0.6,0-1,0.4-1,1v21h-4V13z  M45,55.6l-6.3-6.3c-0.4-0.4-1-0.4-1.4,0L30,56.6l-3.3-3.3c-0.4-0.4-1-0.4-1.4,0L19,59.6V41h26V55.6z M20.4,61l5.6-5.6l2.6,2.6 l-3,3H20.4z M30.7,58.7l7.3-7.3l7,7V61H28.4L30.7,58.7z M19,39V19h26v20H19z M51,67H13V41h4v21l0,0c0,0.1,0,0.2,0.1,0.3l0,0l0,0 c0,0.1,0.1,0.2,0.2,0.3c0,0,0.1,0,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0.1,0.4,0.1h28c0.6,0,1-0.4,1-1V41h4v26H51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,50c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3S24.3,50,26,50z M26,46c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1 S25.4,46,26,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,13c0.6,0,1-0.4,1-1v-2h2c0.6,0,1-0.4,1-1s-0.4-1-1-1H9C8.4,8,8,8.4,8,9v3C8,12.6,8.4,13,9,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55,8h-3c-0.6,0-1,0.4-1,1s0.4,1,1,1h2v2c0,0.6,0.4,1,1,1s1-0.4,1-1V9C56,8.4,55.6,8,55,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55,67c-0.6,0-1,0.4-1,1v2h-2c-0.6,0-1,0.4-1,1s0.4,1,1,1h3c0.6,0,1-0.4,1-1v-3C56,67.4,55.6,67,55,67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,70h-2v-2c0-0.6-0.4-1-1-1s-1,0.4-1,1v3c0,0.6,0.4,1,1,1h3c0.6,0,1-0.4,1-1S12.6,70,12,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29,24h6c0.6,0,1-0.4,1-1s-0.4-1-1-1h-6c-0.6,0-1,0.4-1,1S28.4,24,29,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,28h17c0.6,0,1-0.4,1-1s-0.4-1-1-1H25c-0.6,0-1,0.4-1,1S24.4,28,25,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42,29H22c-0.6,0-1,0.4-1,1s0.4,1,1,1h20c0.6,0,1-0.4,1-1S42.6,29,42,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42,32H22c-0.6,0-1,0.4-1,1s0.4,1,1,1h20c0.6,0,1-0.4,1-1S42.6,32,42,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38,35H22c-0.6,0-1,0.4-1,1s0.4,1,1,1h16c0.6,0,1-0.4,1-1S38.6,35,38,35z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcr);
export default __webpack_public_path__ + "static/media/ocr.349ba2091feefa8d87a937611e3d5f46.svg";
export { ForwardRef as ReactComponent };